
import { z } from 'zod';
import { secureValidationSchemas } from '@/utils/security/secureValidation';

/**
 * Secure authentication schemas with enhanced password requirements
 */
export const secureSignUpSchema = z.object({
  email: secureValidationSchemas.secureEmail,
  password: secureValidationSchemas.strongPassword,
  confirmPassword: secureValidationSchemas.strongPassword,
  first_name: secureValidationSchemas.secureName,
  last_name: secureValidationSchemas.secureName,
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"],
});

export const secureSignInSchema = z.object({
  email: secureValidationSchemas.secureEmail,
  password: z.string().min(1, 'Password is required'),
});

export const secureForgotPasswordSchema = z.object({
  email: secureValidationSchemas.secureEmail,
});

export const secureResetPasswordSchema = z.object({
  password: secureValidationSchemas.strongPassword,
  confirmPassword: secureValidationSchemas.strongPassword,
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"],
});

export type SecureSignUpSchema = z.infer<typeof secureSignUpSchema>;
export type SecureSignUpData = SecureSignUpSchema; // Add the missing export
export type SecureSignInSchema = z.infer<typeof secureSignInSchema>;
export type SecureForgotPasswordSchema = z.infer<typeof secureForgotPasswordSchema>;
export type SecureResetPasswordSchema = z.infer<typeof secureResetPasswordSchema>;
